import request from '@/utils/request';


export function getCustomizedList(params) {
    return request({
        method: 'get',
        url: 'video/getCustomizedList',
		params
    })
}

export function customized(data) {
    return request({
        method: 'post',
        url: 'video/customized',
		data:data
    })
}


export function updateCustomized(data) {
    return request({
        method: 'post',
        url: 'video/updateCustomized',
		data:data
    })
}

export function deleteCustomized(params) {
    return request({
        method: 'get',
        url: 'video/deleteCustomized',
		params
    })
}

